// extracted by mini-css-extract-plugin
module.exports = {"container":"StaticContent_container__viFgW","featuredImage":"StaticContent_featuredImage__xooCi"};